/**
 * Created by liuqiang on 2019/04/29
 *
 * 数据请求统一封装
 */

//导入模块
import axios from 'axios'
import Ls from "@/config/storage"
import router from '@/router'
import Bridge from "@/config/bridge.js"
/*import store from '@/store'*/

/*import {
  Message
} from 'element-ui'*/
import {
  Toast,
  Indicator
} from 'mint-ui'
import {
  apifuture
} from './env'

export default function fetch(options) {
  return new Promise((resolve, reject) => {
    Indicator.open({
      // text: '加载中...',
      spinnerType: 'fading-circle'
    });
    var headers = {};
    //处理请求接口
    if (options.url.indexOf("http") != -1) {
      options.baseURL = ""
    } else {
      options.baseURL = apifuture
      headers = {
        "userId": options.userId || '', // 当前登录用户ID(未登录传空)
        "auth": options.auth || '' // 当前登录用户Auth(未登录传空)
      }
    }

    // console.log(options.baseURL)
    /*const service = axios.create({

    })*/

    axios({
      method: "POST",
      headers: headers,
      url: `${options.baseURL}${options.url}`,
      data: options.params
    }).then(res => {
      console.log(res)

      if (res.data == 1) {
        resolve(res.data)
        Indicator.close();
      } else if (res.data.response && res.data.response.state === "True") {
        resolve(res.data)
        Indicator.close();
      } else if (res.data.Response) {
        resolve(res.data)
        Indicator.close();
      } else {
        // if(res.data.data.error == "登陆失效，请重新登陆"){
        // Ls.clear();
        // router.replace({
        //   path: '/login',
        //   // query: {
        //   //   redirect: router.currentRoute.fullPath
        //   // }
        // });
        // }
        Indicator.close();
        // Toast({
        //   message: res.data.data.error,
        //   position: "bottom",
        //   duration: 1500
        // });
        console.log("成功:" + `${options.baseURL}${options.url}`)
        reject(res.data)
      }
    }).catch(error => {
      // console.log("err")
      // console.log(error)
      Indicator.close();
      console.log("异常:" + `${options.baseURL}${options.url}`)
      Toast({
        message: "请求异常" + error,
        position: "bottom",
        duration: 1500
      });
      reject(error);
    })

  })
}



// WEBPACK FOOTER //
// ./src/api/fetch.js